import type { ReactNode } from 'react';
import { forwardRef } from 'react';

import type { MatchInquiryReportData } from '../types';
import { BaseReport } from '../../reports/BaseReport';
import { useMatchInquiryReportSections } from '../hooks/useMatchInquiryReportSections';

type MatchInquiryReportProps = MatchInquiryReportData & {
  disableSectionObserver?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
};

export const MatchInquiryReport = forwardRef<HTMLDivElement, MatchInquiryReportProps>(
  ({ disableSectionObserver = false, header, footer, ...data }, ref) => {
    const { sections } = useMatchInquiryReportSections(data);

    if (sections.length === 0 && !footer) {
      return null;
    }

    return (
      <BaseReport
        ref={ref}
        sections={sections}
        disableSectionObserver={disableSectionObserver}
        header={header}
        footer={footer}
      />
    );
  },
);

MatchInquiryReport.displayName = 'MatchInquiryReport';
